import { getInitialStateRC } from './state';

export const setDatos = (state, datos) => { state.datos = datos; };
export const setDocumentos = (state, documentos) => { state.documentos = documentos; };
export const resetState = (state) => { Object.assign(state, getInitialStateRC()); };
